<template>
  <div class="register-artist">
    <div class="d-flex justify-space-between align-center mb-2 gap-4">
      <v-text-field
        v-model="search"
        label="Pesquisar"
        outlined
        hide-details
        dense
      ></v-text-field>
      <v-btn color="primary" small @click="openDialog">
        <v-icon left small> mdi-plus </v-icon>
        Artista
      </v-btn>
    </div>

    <v-progress-linear v-if="loading" indeterminate color="primary" />
    <v-alert v-if="error" type="error" dismissible @input="clearError">
      {{ error }}
    </v-alert>

    <p
      v-if="filteredArtists.length === 0"
      class="text-caption text--secondary mb-0 text-center"
    >
      Nenhum artista encontrado
    </p>
    <p v-else class="text-caption text--secondary mb-0 text-center">
      {{ filteredArtists.length }} artista{{
        filteredArtists.length > 1 ? "s" : ""
      }}
      encontrado{{ filteredArtists.length > 1 ? "s" : "" }}
    </p>

    <v-row dense class="mx-0">
      <v-col
        v-for="artist in filteredArtists"
        :key="artist.id"
        cols="12"
        md="6"
        lg="4"
        xl="3"
      >
        <ArtistCard
          :artist="artist"
          @artist-updated="handleArtistUpdated"
          class="h-full"
        />
      </v-col>
    </v-row>

    <NewArtistDialog
      v-model="dialogOpen"
      @artist-saved="handleArtistSaved"
      @error="handleError"
    />
  </div>
</template>

<script>
import NewArtistDialog from "./ArtistDialog.vue";
import ArtistCard from "./ArtistCard.vue";
import registrationsService from "@/services/admin/registrations";
export default {
  name: "Artist",
  components: {
    NewArtistDialog,
    ArtistCard,
  },
  data() {
    return {
      dialogOpen: false,
      error: null,
      loading: false,
      search: "",
      artists: [],
    };
  },
  methods: {
    openDialog() {
      this.dialogOpen = true;
    },
    handleArtistSaved(newArtist) {
      this.artists.push(newArtist);
      this.error = null;
    },
    handleArtistUpdated(updatedArtist) {
      const index = this.artists.findIndex(
        (artist) => artist.id === updatedArtist.id
      );
      if (index !== -1) this.$set(this.artists, index, updatedArtist);
    },
    handleError(errorMessage) {
      this.error = errorMessage;
    },
    clearError() {
      this.error = null;
    },
    async fetchArtists() {
      this.loading = true;
      try {
        const response = await registrationsService.getAllArtists();
        this.artists = response.artists;
      } catch (error) {
        this.error =
          error.message ||
          "Erro ao carregar artistas. Por favor, tente novamente.";
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    filteredArtists() {
      return this.artists.filter(
        (artist) =>
          artist.name.toLowerCase().includes(this.search.toLowerCase()) ||
          artist.shortDescription
            .toLowerCase()
            .includes(this.search.toLowerCase())
      );
    },
  },
  mounted() {
    this.fetchArtists();
  },
};
</script>

<style scoped></style>
